module.exports = __webpack_public_path__ + "static/media/Q_Spades.2d09b22a.svg";